// src/components/lesson/KeyConceptTemplate.jsx

import React from "react";
import {
  useNavigate,
} from "react-router-dom";

import LessonShell from "./LessonShell";
import LessonMedia from "./LessonMedia";

const TEMP_CONCEPT_IMAGE =
  "https://placehold.co/900x900/F1F1F1/111111?text=Replace+Concept+Media";

export default function KeyConceptTemplate({
  /*
   * Existing content
   */
  title = "",
  paragraphs = [],

  imageSrc = "",
  imageAlt =
    "Learning concept",

  /*
   * Navigation
   */
  nextLabel = "Next",
  nextTo,
  playUrl,
  onNext,

  backTo,
  backLabel = "Back",
  onBack,

  /*
   * Concept info
   */
  conceptNumber = 1,
  conceptTotal = 1,

  progressStep = 4,
  progressTotal = 11,

  /*
   * Optional compatibility
   */
  highlight = "",

  videoSrc = "",
  videoPoster = "",

  animationSrc = "",

  mediaType = "",
  mediaLabel = "",

  conceptIcon,
}) {
  const navigate =
    useNavigate();

  const handleNext = () => {
    if (onNext) {
      onNext();
      return;
    }

    if (!nextTo) {
      return;
    }

    if (
      typeof playUrl ===
      "function"
    ) {
      navigate(
        playUrl(
          nextTo
        )
      );

      return;
    }

    navigate(nextTo);
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    if (backTo) {
      if (
        typeof playUrl ===
        "function"
      ) {
        navigate(
          playUrl(
            backTo
          )
        );

        return;
      }

      navigate(
        backTo
      );

      return;
    }

    navigate(-1);
  };

  const resolvedMediaType =
    mediaType ||
    (videoSrc
      ? "video"
      : animationSrc
      ? "animation"
      : "image");

  const suppliedMediaSrc =
    resolvedMediaType ===
    "video"
      ? videoSrc
      : resolvedMediaType ===
        "animation"
      ? animationSrc
      : imageSrc;

  const resolvedMediaSrc =
    suppliedMediaSrc ||
    TEMP_CONCEPT_IMAGE;

  return (
    <LessonShell
      progressStep={
        progressStep
      }
      progressTotal={
        progressTotal
      }

      showBack
      backLabel={
        backLabel
      }
      onBack={
        handleBack
      }

      showNext
      nextLabel={
        nextLabel
      }
      onNext={
        handleNext
      }

      contentClassName="
        pt-8
      "
    >
      {/*
       * The final Canva concept pages
       * intentionally contain no separate
       * "SECTION 1: LEARNING IDEA" label.
       *
       * The content itself sits inside the
       * media card.
       */}

      <div
        className="
          mx-auto
          mt-10
          w-full
          max-w-[560px]
        "
      >
        <div
          className="
            overflow-hidden
            rounded-[28px]
            bg-[#F1F1F1]
          "
        >
          <LessonMedia
            type={
              resolvedMediaType
            }
            src={
              resolvedMediaSrc
            }
            poster={
              videoPoster
            }
            alt={
              imageAlt
            }
            label={
              mediaLabel ||
              title ||
              `Concept ${conceptNumber}`
            }

            controls={
              resolvedMediaType ===
              "video"
            }

            autoPlay={
              resolvedMediaType ===
              "animation"
            }

            loop={
              resolvedMediaType ===
              "animation"
            }

            muted={
              resolvedMediaType ===
              "animation"
            }
          />
        </div>
      </div>

      {/*
       * Keep old props accepted so Sanity
       * does not break while we transition.
       *
       * Canva now places this educational
       * copy inside the visual/animation,
       * so it is intentionally hidden here.
       */}
      {false && (
        <>
          <h1>
            {title}
          </h1>

          {paragraphs.map(
            (
              paragraph,
              index
            ) => (
              <p key={index}>
                {paragraph}
              </p>
            )
          )}

          <p>
            {highlight}
          </p>

          <span>
            {conceptTotal}
          </span>

          <span>
            {conceptIcon}
          </span>
        </>
      )}
    </LessonShell>
  );
}